import axios from 'axios'
import  { checkErrorData, checkErrorDataNull } from './authAction'
import  { formatList, capitalize, capitalizeWord, orderByAsc } from './format'

export function newLocalisation(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "CREATE_LOCALISATION_START", payload: "" })

            console.log("new Localisation START", {data})
            const res = await axios.post('/localisations/new',{data})
            console.log({res});            
                        
            if (checkErrorData(res, "CREATE_LOCALISATION_ERROR", dispatch ) ) {
                // res.data.loc_name = capitalizeWord(res.data.loc_name)

				dispatch({ type: "NEW_LOCALISATION", payload: res.data })
				dispatch({ type: "CREATE_LOCALISATION_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] new localisation ", err);
            dispatch({
                type: "CREATE_LOCALISATION_ERROR",
                payload: err
            })
        }
    }
}

export function fetchParentLocalisations() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_PARENT_LOCALISATIONS_START", payload: "" })

            console.log("fetch Localisation START")
            const res = await axios.get('/localisations/parent/get/all')
            console.log({res});
            
            if (checkErrorData(res, "FETCH_PARENT_LOCALISATIONS_ERROR", dispatch ) ) { 
                dispatch({
                    type: "GET_PARENT_LOCALISATIONS",
                    payload: formatList(orderByAsc(res.data, "loc_name"), "loc_id")
                })
                dispatch({ type: "FETCH_PARENT_LOCALISATIONS_FULFILLED", payload: "" })
                
            } 
        } catch(err) {
            console.log("[ERROR] get localisations list ", err);
            dispatch({ type: "FETCH_PARENT_LOCALISATIONS_ERROR", payload: err })
        }
    }
}

export function fetchChildLocalisations() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_CHILD_LOCALISATIONS_START", payload: "" })

            console.log("fetch Localisation START")
            const res = await axios.get('/localisations/child/get/all')
            console.log({res});
            
            if (checkErrorData(res, "FETCH_CHILD_LOCALISATIONS_ERROR", dispatch ) ) { 
                dispatch({
                    type: "GET_CHILD_LOCALISATIONS",
                    payload: formatList(orderByAsc(res.data, "loc_name"), "loc_id")
                })
                dispatch({ type: "FETCH_CHILD_LOCALISATIONS_FULFILLED", payload: "" })

            } 
        } catch(err) {
            console.log("[ERROR] get localisations list ", err);
            dispatch({ type: "FETCH_CHILD_LOCALISATIONS_ERROR", payload: err })
        }
    }
}
export function refetchLocalisations() {
    return async function(dispatch){
        try{
            console.log("refetch Localisation START")
            const resP = await axios.get('/localisations/parent/get/all')
            const resC = await axios.get('/localisations/child/get/all')
            
            if (!resP.data.error && !resC.data.error ){
                let list = {
                    PARENT: {},
                    CHILD: {},
                    NAMES: {},
                    LIST: {},
                    ALL: {},
                }
                list.PARENT = formatList(orderByAsc(resP.data, "loc_name"), "loc_id")
                
                list.CHILD = formatList(orderByAsc(resC.data, "loc_name"), "loc_id")
                list.NAMES = Object.assign(
                    formatList(orderByAsc(resP.data, "loc_name"), "loc_id"),
                    formatList(orderByAsc(resC.data, "loc_name"), "loc_id")
                )

                Object.values(list.CHILD).forEach( cat => {

                    if(!cat.loc_sub_parent){
                        if(list.LIST[cat.loc_parent]){
                            list.LIST[cat.loc_parent].push(cat.loc_id)
                        } else {
                            list.LIST[cat.loc_parent] = [cat.loc_id]
                        }

                    } else {
                        if(list.LIST[cat.loc_sub_parent]){
                            list.LIST[cat.loc_sub_parent].push(cat.loc_id)
                        } else {
                            list.LIST[cat.loc_sub_parent] = [cat.loc_id]
                        }
                    }
    
                    if(list.ALL[cat.loc_parent]){
                        list.ALL[cat.loc_parent].push(cat.loc_id)
                    } else {
                        list.ALL[cat.loc_parent] = [cat.loc_id]
                    }
                })
                dispatch({
                    type: "REFETCH_LOCALISATIONS",
                    payload: list
                })
            } else {
				console.log("ERROR", resP.data.error, resC.data.error);				
			}
        } catch(err) {
            console.log("[ERROR] refetch localisations list ", err);
        }
    }
}
export function updateLocalisation(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "UPDATE_LOCALISATION_START", payload: "" })

            console.log("update Localisation START")
            const res = await axios.post("/localisations/update", {data})
            console.log({res});
            
            if (checkErrorData(res, "UPDATE_LOCALISATION_ERROR", dispatch ) ) { 
                // dispatch(refetchLocalisations())
                dispatch({
                    type: "UPDATE_LOCALISATION",
                    payload: data
                })
                dispatch({ type: "UPDATE_LOCALISATION_FULFILLED", payload: "" })
            }
        } catch(err) {
            console.log("[ERROR] update localisation ", err);
            dispatch({
                type: "UPDATE_LOCALISATION_ERROR",
                payload: err
                
            })
        }
    }
}